/**
 * Javascript file for the forgot password(password reset) page.
 * @author Adrian Rebmann, Andrea Villeda
 */

import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { changePasswordWithHash } from "../../../../../api";

export default {
  name: "ForgotPass",
  props: ["hash"],

  /**
   * The vue instance's data object.
   * @property {boolean} error - There has been an error.
   * @property {boolean} sending - Information is currently being processed.
   * @property {string} form.password - the user's updated password.
   */
  data() {
    return {
      error: false,
      sending: false,
      form: {
        password: ""
      }
    };
  },

  /**
   * Validation to be done to the data.
   * @property {*} form.password - the user's new password.
   * @property {*} form.repassword - the user's retype of the new password.
   */
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8)
      },
      repassword: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Determines if the field is invalid or not.
     * @param {string} fieldName - Name of the Field.
     */
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },

    /**
     * Resets the form.
     */
    clearForm() {
      this.$v.$reset();
      //new password
      this.form.password = null;
      //old password
      this.form.repassword = null;
    },

    /**
     * Updates the user's password and returns to the "Signin" page.
     */
    changePass() {
      changePasswordWithHash(this.hash, this.form.password)
        .then(res => {
          this.$router.push({ name: "Signin" });
        })
        .catch(err => {
          console.log(err);
          this.error = true;
          window.setTimeout(() => {
            this.error = false;
          }, 3000);
        });
    },

    /**
     * Validates the new password. If it's valid, it updates it.
     */
    validatePass() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.changePass();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/authentication/signin/forgotpass/forgotpass.js